import { Typography } from 'antd';
import { ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

const PageTitle = ({ children }: Props) => {
  return (
    <Typography.Title level={1} data-testid="pageTitleId">
      {children}
    </Typography.Title>
  );
};

export default PageTitle;
